import React from "react";

function IdDetailed() {
  return (
    <section className="relative py-16 px-6 overflow-hidden bg-[#f8f8f8] dark:bg-[#050505] transition-colors duration-300">
      {/* BACKGROUND EFFECTS */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/10 blur-[140px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[140px] rounded-full" />

      {/* GRID */}
      <div className="absolute inset-0 opacity-60 bg-[linear-gradient(to_right,rgba(0,0,0,0.06)_1px,transparent_1px),linear-gradient(to_bottom,rgba(0,0,0,0.06)_1px,transparent_1px)] dark:bg-[linear-gradient(to_right,rgba(255,255,255,0.06)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.06)_1px,transparent_1px)] bg-[size:60px_60px]" />

      {/* CONTENT SECTION */}
      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="bg-white dark:bg-[#1a1a1a] p-10 md:p-16 rounded-[2rem] border border-gray-100 dark:border-gray-800 shadow-xl shadow-gray-500/5">
          {/* TITLE */}
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 dark:text-white mb-8">
            Professional Interior Design Services for Homes, Offices &
            Commercial Spaces
          </h2>

          {/* CONTENT */}
          <div className="text-gray-600 dark:text-gray-400 text-md space-y-6">
            <p>
              At <strong>Web X Secure Interiors</strong>, we specialize in
              creating modern, functional, and visually stunning interior spaces
              that enhance comfort, productivity, and lifestyle. Our
              professional interior design services are tailored for residential
              homes, corporate offices, retail outlets, commercial
              establishments, and luxury living spaces. We believe that great
              interior design is not only about aesthetics but also about
              creating spaces that improve everyday experiences.
            </p>

            <p>
              Our team combines creativity, innovation, and practical design
              principles to deliver customized interior solutions that align
              with your vision and requirements. From space planning and
              furniture layouts to color schemes, lighting design, ceiling
              concepts, and décor selection, every detail is carefully planned
              to achieve the perfect balance between beauty and functionality.
            </p>

            <p>
              Whether you are building a new home, renovating an existing
              property, or designing a modern office environment, we provide
              end-to-end interior design services that simplify the entire
              process. Our experts analyze your space, understand your lifestyle
              needs, and create personalized concepts that maximize available
              space while maintaining elegance and efficiency.
            </p>

            <p>
              We utilize advanced 3D visualization and modern design
              technologies that allow clients to preview their interior spaces
              before execution. This approach ensures better decision-making,
              reduces project uncertainties, improves design accuracy, and helps
              achieve the desired outcome with confidence.
            </p>

            <p>
              Our interior design expertise includes home interior design,
              office interior design, commercial interior design, modular
              kitchen design, bedroom design, living room transformation,
              workspace optimization, furniture planning, false ceiling design,
              lighting solutions, and complete space renovation services. Every
              project is executed with attention to detail, quality
              craftsmanship, and premium finishing standards.
            </p>

            <p>
              At Web X Secure Interiors, our mission is to transform ordinary
              spaces into inspiring environments that reflect personality,
              improve functionality, and create lasting impressions. By
              combining modern design trends, innovative materials, and
              strategic space planning, we help clients create interiors that
              are stylish, comfortable, and built for long-term value.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default IdDetailed;
